import { render, staticRenderFns } from "./profile-family.vue?vue&type=template&id=43da0294&scoped=true&"
import script from "./profile-family.ts?vue&type=script&lang=ts&"
export * from "./profile-family.ts?vue&type=script&lang=ts&"
import style0 from "./profile-family.scss?vue&type=style&index=0&id=43da0294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da0294",
  null
  
)

export default component.exports